import { React, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import FormHelpers from "../helpers/FormHelpers";
import RequestForm from "./Forms/RequestForm";
import AddToCartForm from "./Forms/AddToCartForm";

import { sendCartData } from "../store/configurator-actions";

function FormArea() {
  const dispatch = useDispatch();

  const formStep = useSelector((state) => state.configurator.FormStep);

  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );
  const requestDetails = currentRequest.DonorRequest;

  return (
    <div>
      {formStep === "Request" && <RequestForm />}
      {formStep === "AddToCart" && <AddToCartForm />}
    </div>
  );
}

export default FormArea;
